import React, { useEffect, useState } from "react";

type Props = {
  initialValue: number;
  onQtyChange: (value: number) => Promise<void>;
};

export const CartQty: React.FC<Props> = ({ initialValue, onQtyChange }) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (value: number) => {
    setValue(value);
    onQtyChange(value);
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <div className="_field qty">
      <input type="number" value={value} onChange={(e) => handleChange(parseInt(e.target.value))} />
      <button tabIndex={-1} onClick={() => handleChange(value - 1)}>
        <div className="qty-btn-wrap">
          <ui-icon name="icon-minus" />
        </div>
      </button>
      <button tabIndex={-1} onClick={() => handleChange(value + 1)}>
        <div className="qty-btn-wrap">
          <ui-icon name="icon-plus" />
        </div>
      </button>
    </div>
  );
};
